
import { defineComponent } from 'vue';
import { piniaAvailable } from '../helpers/piniaStoreAvailable';
import HokIcon from './HokIcon.vue';

export default defineComponent({
	name: 'CopyURLToClipboard',
	components: { HokIcon },
	data() {
		return {
			openTooltip: false,
			copied: false,
			piniaAvailable
		};
	},
	computed: {
		host(): string | undefined {
			return piniaAvailable(this.$nuxt, '$userRootStore')
				? this.$nuxt.context.$userRootStore?.host
				: this.$store?.state?.host;
		}
	},
	methods: {
		copyToClipboard() {
			this.copied = true;
			setTimeout(() => {
				this.copied = false;
			}, 3000);
			if (this.pageElement) {
				this.$trackCompanyEvent('click_copy_to_clipboard', { pageElement: this.pageElement });
			}
			if (this.fullPath) {
				this.copyStringToClipboard(this.fullPath);
			} else {
				const url = new URL(this.host || '', 'https://hokify.com');
				if (this.pathName) {
					url.pathname = this.pathName;
				} else {
					throw new Error('No valid URL');
				}
				this.copyStringToClipboard(url.toString());
			}
			this.$snack.show({
				text: this.message
			});
		},
		copyStringToClipboard(str: string) {
			const el = document.createElement('textarea');
			el.value = str;
			el.setAttribute('readonly', '');
			el.style.cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';

			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
		}
	},
	props: {
		toolTip: { type: String, default: '' },
		message: { type: String, default: 'Link in die Zwischenablage kopiert' },
		pathName: { type: String, required: false, default: '' },
		fullPath: { type: String, required: false, default: '' },
		pageElement: { type: String, required: false },
		inlineIcon: { type: Boolean, default: true },
		size: {
			type: Number,
			default: 4
		},
		color: {
			type: String,
			default: 'default'
		}
	}
});
